import React from 'react';
import { ShadowBorderContainer, Text } from '../../../tw-components';
import calendarIcon from '../../../../../images/calendar-illustration.svg';
import Button from '../../../button';
import { enums } from '../../../../../utils';
import { useHistory } from 'react-router';
import { KenticoDataContext } from '../../../../../contexts/kentico-data-context';
import { PersonDataContext } from '../../../../../contexts/person-data-context';

interface LeaveLogicCardProps {
  ntn: string;
}

export const LeaveLogicCard = ({ ntn }: LeaveLogicCardProps) => {
  const { config } = React.useContext(KenticoDataContext);
  const { personData } = React.useContext(PersonDataContext);
  const history = useHistory();

  const planId = personData?.submissions?.submissions?.find(
    (s) => s.notificationId === ntn,
  )?.planId;

  const handleClick = (relayState?: string) => {
    const base = config['leavelogic_url'];
    const url = relayState
      ? `${base}&RelayState=${encodeURIComponent(relayState)}`
      : base;

    history.push({
      pathname: `${enums.AppPaths.externalRedirect}/leave-logic`,
      state: { redirectUrl: url },
    });
  };

  if (!planId) {
    return null;
  }

  return (
    <div className="tw-flex tw-gap-x-4 tw-mb-3">
      <ShadowBorderContainer className="tw-w-full tw-flex tw-flex-col sm:tw-flex-row tw-gap-x-2">
        <div className="tw-flex tw-w-full sm:tw-w-1/4 items-center tw-justify-center md:tw-w-1/4 tw-mb-2">
          <img
            className="tw-flex tw-w-1/4 sm:tw-w-2/3"
            src={calendarIcon}
            alt="Calendar Icon"
          ></img>
        </div>
        <div className="tw-w-full md:tw-w-3/4">
          <Text
            className="tw-mb-3 tw-font-semibold tw-text-center sm:tw-text-left"
            color="unm-interactive01-400"
          >
            Navigate Your Leave with Confidence
          </Text>
          <Text className="tw-text-center sm:tw-text-left">
            Manage your leave-related check-list and explore potential state and
            employer benefits — all within Leave Logic, our partner tool
            designed to help you understand your options and how they may
            support you.
          </Text>
          <div className="tw-flex tw-flex-col tw-gap-6 tw-mt-5 sm:tw-flex-row">
            <Button
              id="ll-benefits"
              buttonStyle={enums.ButtonTypes.secondary}
              className="tw-w-full"
              hPadding={24}
              onClick={() =>
                handleClick(`/webapp/leave_plans/${planId}/leave_plan_benefits`)
              }
            >
              Benefits in Leave Logic
            </Button>
            <Button
              id="ll-to-dos"
              buttonStyle={enums.ButtonTypes.secondary}
              className="tw-w-full"
              onClick={() =>
                handleClick(`/webapp/leave_plans/${planId}/schedules`)
              }
              disabled={false}
              hPadding={16}
            >
              Leave Logic Checklist
            </Button>
          </div>
        </div>
      </ShadowBorderContainer>
    </div>
  );
};
